import { ImportInputComponent } from './import-input/import-input.component';
import { ImportComponent } from './import.component';
import { ImportMapFieldsComponent } from './map-fields/map-fields.component';
import { ImportSendDataComponent } from './send-data/send-data.component';
import { ImportValidationComponent } from './validation/validation.component';

export const DATA_IMPORT_DECLARATIONS: any[] = [
  ImportComponent,
  ImportValidationComponent,
  ImportSendDataComponent,
  ImportMapFieldsComponent,
  ImportInputComponent
];
